
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.97 10.478a5.237 5.237 0 005.234-5.239A5.237 5.237 0 0010.97 0a5.237 5.237 0 00-5.234 5.24 5.237 5.237 0 005.234 5.238zM23.756 10.478A5.237 5.237 0 0028.99 5.24 5.237 5.237 0 0023.756 0a5.237 5.237 0 00-5.234 5.24 5.237 5.237 0 005.234 5.238zM21.203 23.945c.005-.164.01-.334.01-.503 0-5.59-4.528-10.117-10.106-10.117C5.528 13.325 1 17.858 1 23.442c0 .17.005.334.01.503","fill":"#000"}}),_c('path',{attrs:{"d":"M21.203 23.945c.005-.164.01-.334.01-.503 0-5.59-4.528-10.117-10.106-10.117C5.528 13.325 1 17.858 1 23.442c0 .17.005.334.01.503","stroke":"#fff","stroke-width":"1.279","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M33.99 23.945c.005-.164.01-.334.01-.503 0-5.59-4.528-10.117-10.107-10.117-5.578 0-10.107 4.533-10.107 10.117 0 .17.006.334.011.503","fill":"#000"}}),_c('path',{attrs:{"d":"M33.99 23.945c.005-.164.01-.334.01-.503 0-5.59-4.528-10.117-10.107-10.117-5.578 0-10.107 4.533-10.107 10.117 0 .17.006.334.011.503","stroke":"#fff","stroke-width":"1.279","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    